<script setup lang="ts">
import type { Appearance } from '@/composables/useAppearance'
import { useAppearance } from '@/composables/useAppearance'

const { appearance, updateAppearance } = useAppearance()

const items = [
  {
    label: 'Light',
    description: 'Use a light interface.',
    icon: 'i-lucide-sun',
    value: 'light',
  },
  {
    label: 'Dark',
    description: 'Use a dark interface.',
    icon: 'i-lucide-moon',
    value: 'dark',
  },
  {
    label: 'System',
    description: 'Follow your device preference.',
    icon: 'i-lucide-monitor',
    value: 'system',
  },
]

function isAppearance(value: unknown): value is Appearance {
  return value === 'light' || value === 'dark' || value === 'system'
}

function updateSelectedAppearance(value: unknown) {
  if (isAppearance(value)) {
    updateAppearance(value)
  }
}
</script>

<template>
  <URadioGroup
    :model-value="appearance"
    :items="items"
    variant="card"
    orientation="horizontal"
    class="max-w-3xl"
    :ui="{
      fieldset: 'grid gap-3 sm:grid-cols-3',
      item: 'items-start',
    }"
    @update:model-value="updateSelectedAppearance"
  >
    <template #label="{ item }">
      <span class="flex items-center gap-2">
        <UIcon :name="item.icon" class="text-primary size-4" />
        {{ item.label }}
      </span>
    </template>
  </URadioGroup>
</template>
